import AnnotationView from './AnnotationView'

export default AnnotationView
